import React from 'react';
import { IArticle } from '../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const chto_takoe_erir: IArticle = {
  title: 'Что такое ЕРИР и его роль в маркировке интернет-рекламы',
  image: '/assets/img/blog/chto_takoe_erir.jpeg',
  prewievImage: '/assets/img/blog/chto_takoe_erir-prewiev.jpeg',
  content: [
    {
      subTitle: 'Что такое ЕРИР?',
      text: [
        'ЕРИР (Единый реестр интернет-рекламы) – это структура, созданная Роскомнадзором для реализации норм по маркировке рекламы в соответствии с требованиями статьи 18.1 закона «О рекламе» №38-ФЗ. ЕРИР обеспечивает контроль и прозрачность в сфере интернет-рекламы и обязывает рекламных агентов и других игроков рынка передавать данные о рекламных материалах, составе и участниках рекламных кампаний в Единый реестр интернет-рекламы.',
      ],
    },
    {
      subTitle: 'Зачем необходим ЕРИР? Его функции и назначение',
      text: [
        'ЕРИР представляет собой централизованную базу данных, предназначенную для хранения и систематизации сведений о размещении интернет-рекламы на территории России. Его главная задача — сделать рекламный рынок более прозрачным и противодействовать противоправной рекламе.',
        'ЕРИР дает возможность контролирующим органам (Роскомнадзор, ФАС, ФНС), следить за соблюдением законодательства, выявлять незаконную рекламу и обеспечивать прозрачность рекламного рынка. Поступающие в ЕРИР данные, позволяют отслеживать размещение рекламы, в том числе рекламу, содержащую недостоверную информацию или нарушающую права третьих лиц. Кроме того, реестр предоставляет возможности для статистического анализа данных.',
        <a
          href="https://rkn.gov.ru/docs/Otchet_o_rynke_internet_reklamy_v_I_polugodii_2024_goda_na_osnove.pdf"
          target="_blank"
          rel="noreferrer"
        >
          Отчёт ЕРИР / Роскомнадзор о рынке интернет рекламы за первое полугодие
          2024 года на основе данных маркировки рекламы в ЕРИР
        </a>,
      ],
    },
    {
      subTitle:
        'Кто ответственен за передачу данных и как проверить идентификатор рекламы (ERID)',
      text: [
        'Согласно статье 18.1 Закона "О рекламе" (№38-ФЗ), данные должны предоставлять рекламодатели, рекламораспространители, рекламные агентства и операторы рекламных систем. Передача осуществляется только через одного из аккредитованных Роскомнадзором оператора рекламных данных (ОРД). ОРД от SberAds является одним из семи аккредитованных операторов.',
        'Категории участников, ответственных за маркировку рекламы и передачу данных в ЕРИР:',
        <ul>
          <li>
            <strong>Рекламодатели (РД):</strong> физические лица или
            организации, которые заказывают и оплачивают размещение рекламы.
          </li>
          <li>
            <strong>Рекламораспространители (РР)</strong>: платформы и сайты,
            размещающие рекламу на своих ресурсах.
          </li>
          <li>
            <strong>Рекламные агентства (РА)</strong>: посредники, создающие
            рекламный контент и обеспечивающие процесс размещения рекламы.
          </li>
          <li>
            <strong>Операторы рекламных систем (ОРС)</strong>: компании,
            управляющие системами доставки рекламы.
          </li>
          <li>
            <strong>Третьи лица:</strong> лица, уполномоченные участниками
            рекламной цепочки за процедуру маркировки рекламы и подачу
            отчетности в ЕРИР. Третьими лицами могут быть, как физические лица,
            так и компании, по роду деятельности, не имеющие прямого отношения к
            рекламному рынку. Подробнее в нашем материале:{' '}
            <a href="/blog/markirovka_reklami_v_internete">
              «Маркировка рекламы в интернете: обзор ключевых моментов»
            </a>
            .
          </li>
        </ul>,
      ],
    },
    {
      subTitle: 'Проверка рекламы по уникальному идентификатору (ERID) в ЕРИР',
      text: [
        'Процесс проверки уникального идентификатора рекламы (erid) в системе ЕРИР осуществляется с помощью специального интерфейса. Для этого следует выполнить следующие действия:',
        'Зарегистрироваться на сайте (https://erir.grfc.ru/) и войти в личный кабинет. Регистрация в личном кабинете на платформе ЕРИР происходит через сервис Госуслуг.',
        'Любой гражданин России, независимо от его причастности к рекламному рынку, может получить доступ к данным о рекламодателе, зафиксированным в ЕРИР.',
        'Каждый участник рынка также может отследить размещение собственной рекламы и факт наличия переданной отчетности.',
        'На главной странице в специально отведенное поле вводится уникальный идентификатор рекламы (ERID), который был получен при регистрации рекламы в ОРД.',
        'Запустив поиск, система выдаст данные о статусе рекламы, включая информацию о ее размещении, соответствии нормативным требованиям и наличии возможных нарушений, либо сообщит о том, что данный маркер в системе не зарегистрирован.',
        'Пользователь системы может запросить детализированный отчет о проверке erid, содержащий всю необходимую информацию для анализа и принятия решения.',
      ],
    },
    {
      subTitle: 'Резюме',
      text: [
        'ЕРИР (Единый реестр интернет-рекламы) - официальный орган Роскомнадзора, хранящий и обрабатывающий базу данных рекламного рынка.',
        'База ЕРИР содержит данные обо всех рекламодателях, размещающих свои объявления в интернете, а также сведения о самих рекламных сообщениях и материалах.',
        'Основная задача ЕРИР — обеспечить полный контроль над интернет-рекламой, гарантируя ее прозрачность и законность размещения.',
        'В базе данных ЕРИР содержатся сведения о различных видах интернет-рекламы, включая контекстную рекламу, таргетированные объявления, баннеры, видео ролики и нативные интеграции с блогерами.',
        'Информация из ЕРИР может быть использована государственными органами, такими как ФНС, для проверки рекламодателей на предмет корректного и своевременного выполнения налоговых обязательств.',
        'Зарегистрировать рекламу и передать сведения об участниках и составе рекламной кампании в ЕРИР можно на сайте ОРД от SberAds.',
      ],
    },
  ],
};

export default chto_takoe_erir;
